<h2 mat-dialog-title>{{ data.code }} history</h2>

<mat-dialog-content class="history-dialog-content">
  <div class="history-state" *ngIf="loading" aria-live="polite">
    <mat-spinner diameter="28"></mat-spinner>
    <span>Loading history...</span>
  </div>

  <div class="history-error" *ngIf="!loading && errorMessage" role="alert">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <div
    class="history-empty"
    *ngIf="!loading && !errorMessage && entries.length === 0"
  >
    No history recorded for this event.
  </div>

  <ol
    class="history-list"
    *ngIf="!loading && !errorMessage && entries.length > 0"
  >
    <li *ngFor="let entry of entries">
      <div class="history-entry-heading">
        <strong>{{ entry.action }}</strong>
        <time *ngIf="entry.changedAt" [attr.datetime]="entry.changedAt">
          {{ entry.changedAt | date: 'medium' }}
        </time>
      </div>
      <div class="history-actor">by {{ actorLabel(entry) }}</div>
      <dl>
        <div *ngIf="entry.fromStatus !== null || entry.toStatus !== null">
          <dt>Status</dt>
          <dd>
            {{ statusLabel(entry.fromStatus) }}
            <mat-icon aria-hidden="true">arrow_forward</mat-icon>
            {{ statusLabel(entry.toStatus) }}
          </dd>
        </div>
        <div
          *ngIf="
            entry.fromCollectorAuthId !== null ||
            entry.toCollectorAuthId !== null
          "
        >
          <dt>Collector</dt>
          <dd>
            {{
              collectorLabel(entry.fromCollectorName, entry.fromCollectorAuthId)
            }}
            <mat-icon aria-hidden="true">arrow_forward</mat-icon>
            {{ collectorLabel(entry.toCollectorName, entry.toCollectorAuthId) }}
          </dd>
        </div>
      </dl>
    </li>
  </ol>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Close</button>
</mat-dialog-actions>
